import React, { Component } from 'react';
import {Route, Switch, BrowserRouter, Redirect} from 'react-router-dom';
import { Provider, connect } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {X} from 'react-feather';
import { PersistGate } from 'redux-persist/integration/react'
import { CookiesProvider, withCookies } from 'react-cookie';

import {auth, shop} from "./actions";
import subsApp from "./reducers";
import Admin from './containers/admin/Admin'
import Help from './components/Help'
import Home from './containers/Home'
import Account from './containers/Account'
import Shop from './containers/Shop'
import Cart from './containers/Cart'
import Checkout from './containers/Checkout'
import Header from './containers/Header';
import Footer from './containers/Footer';
import SignIn from './containers/SignIn';
import SignedIn from './components/SignedIn';
import Landing from './containers/landing/Landing'
import LandingSuccess from './containers/landing/LandingSuccess'
import SavedCart from './components/SavedCart'

import './index.css';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['ux', 'months', 'cart', 'auth']
}

const persistedReducer = persistReducer(persistConfig, subsApp)


const store = createStore(persistedReducer, composeWithDevTools(
    applyMiddleware(thunk,)
))

let persistor = persistStore(store)

const ProtectedRoute
  = ({ isAllowed, ...props }) =>
     isAllowed
     ? <Route {...props}/>
     : <Redirect to="/"/>;

class Storefront extends Component  {
  constructor() {
    super();
    this.state = {
      cartStatus: '',
      cartSaved: false,
      signInStatus: false,
      signedInPopup: false,
    }
  }

  showCart = () => {
    this.setState({cartStatus: 'show'})
  }

  hideCart = () => {
    this.setState({
      cartStatus: '',
      cartSaved: false,
    })
  }

  saveCart = () => {
    this.setState({
      cartSaved: true,
      cartStatus: ''
  })
    setTimeout(() => this.setState({cartSaved: false}), 2000)
  }

  toggleSignIn = () => {
    this.setState(prevState => ({signInStatus: !prevState.signInStatus}))
  }

  toggleSignedInPopup = () => {
    this.setState(prevState => ({signedInPopup: !prevState.signedInPopup}))
    setTimeout(() => {
      this.setState(prevState => ({signedInPopup: !prevState.signedInPopup}))
    }, 2000);
  }

  componentDidUpdate = () => {
    this.props.checkIfApproved()
  }

  componentDidMount(){
    this.props.loadUserCookie()
  }

  render(){
    return(
      <div className="Storefront">
        <div className="webshop-header">
          <a href="https://www.escapat.com/">Gå till vanliga webbshoppen</a>
        </div>
        <Help />
        <SignedIn signedInPopup={this.state.signedInPopup} />
        <Cart
          hideCart={this.hideCart}
          saveCart={this.saveCart}
          cartSaved={this.state.cartSaved}
          cartStatus={this.state.cartStatus}
          />
        <SavedCart cartSaved={this.state.cartSaved} />
        <Route path="/" render={(props) => <Header {...props}
          showCart={this.showCart} toggleSignIn={this.toggleSignIn}/>} />
        <Switch>
          <Route path="/info" component={Home} />
          <Route path="/kassa" component={Checkout}/>
          <ProtectedRoute
            path="/konto"
            isAllowed={this.props.auth.isAuthenticated}
            component={Account}/>
          <Route path="/" component={Shop} />
        </Switch>
        {
          this.state.signInStatus
          ?
          <div className="SignIn-overlay">
            <X className="ProductPopup-x SignIn-x" />
            <SignIn toggleSignIn={this.toggleSignIn}
              toggleSignedInPopup={this.toggleSignedInPopup} />
          </div>
          :
          null
        }
        <Footer />
      </div>
    )
  }
}

class RootContainerComponent extends Component  {

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/backoffice" component={Admin} />
          <Route path="/start/skapad/:id" component={LandingSuccess} />
          <Route path="/start" component={Landing} />
          <Route path="/" render={(props) =>
            <Storefront
              auth={this.props.auth}
              loadUserCookie={this.props.loadUserCookie}
              cart={this.props.cart}
              cookies={this.props.cookies}
              checkIfApproved={this.props.checkIfApproved}/> }
            />
        </Switch>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    cart: state.cart,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadUserCookie: () => {
      return dispatch(auth.loadUserCookie());
    },
    checkIfApproved: () => {
      return dispatch(shop.checkIfApproved());
    }
  }
}

let RootContainer = connect(mapStateToProps, mapDispatchToProps)(RootContainerComponent);

class App extends Component {
  render() {
    return (
      <CookiesProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <RootContainer cookies={this.props.cookies} />
          </PersistGate>
        </Provider>
      </CookiesProvider>
    )
  }
}

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/App.js